
import { SmallUnitService } from './small-units-service.model';

export class SmallUnitadminDTO {
    RequestorId: string;
    StatusId: number;
    Id: string;
    AdminEmail: string;
    SmallUnitReviewActionId: number;
    SmallUnitMoreInformation: string;
    MeasEstimationActionId: number;
    EstimatedFeesValue: number;
    EstimatedNetTonnage: number;
    EstimatedSDR: number;
    MeasEstimationMoreInformation: string;
    MeasEstimationRejectReason: string;
    MarineActionId: number;
    ActualArrivalTime: string;
    MarineCancelationReason: string;
    MeasActualActionId: number;
    ActualLength: number;
    ActualWidth: number;
    ActualDepth: number;
    ActualSCNT: number;
    ActualSCGT: number;
    MeasActualRejectReason: string;
    Swift: string;
    ConfirmedDocument: boolean;
    AgentTransitDate: string;
    SmallUnitTransitActionId: number;
    SmallUnitTransitDate: string;
    SmallUnitTransitMoreInformation: string;
    ISActionId: number;
    ISNotes: string;
    ISMarineActionId: number;
    ISMarineNotes: string;
    SmallUnitConfirmActionId: number;
    SmallUnitConfirmTransitDate: string;
    SmallUnitConfirmMoreInformation: string;
    ISMarineConfirmActionId: number;
    ISMarineConfirmTransitDate: string;
    ISMarineConfirmMoreInformation: string;
    FinalSDR: number;
    InitialSDRDate: Date;
    FinalTransitFeesValue: number;
    FinalTotalFees: number;
    LocalEquiv: number;
    TotalFeesLE: number;
    InvoiceNo: string;
    InvoiceDate: string;
    InvoiceAccountantName: string;
    InvoiceAuditorName: string;
    IsFinalFeesReview: boolean;
    SmallUnitServicesDTO: SmallUnitService[] = [];
    ISMActionId: number;
    ISMNotes:string;
    ISMActualArrivalTime:string
    // ISMSmallUnitTransitActionId: number;
    ISMSmallUnitTransitDate: string;
    ISMSmallUnitTransitMoreInformation: string;
    ISMDepartureNotes:string;
}